export default "__VITE_ASSET__CNxiGewL__"